<template>
    <o-form :title="$t('sandoz.kuko_product_group')"
            :url="`/api/kuko_product_groups/${$route.params.id}`"
            class="ortic-form-horizontal mb-4" ref="form">
        <template slot-scope="props">
            <b-row>
                <b-col>
                  <o-input :label="$t('sandoz.product_group')" errorField="product_group" v-model="props.item.product_group"/>
                  <o-input :label="$t('sandoz.description_scheme')" errorField="description" v-model="props.item.description"/>
                  <o-input :label="$t('sandoz.group_info')" errorField="group_info" v-model="props.item.group_info"/>
                  <o-input :label="$t('sandoz.group_info_color')" errorField="group_info_color" v-model="props.item.group_info_color"/>
                  <o-value-select :items="types" :label="$t('sandoz.category_type')" v-model="props.item.product_group_category"/>
                </b-col>
                <b-col>
                  <o-form-group :label="$t('sandoz.warning')">
                    <vue-editor v-model="props.item.warning" :editor-toolbar="customToolbar" />
                  </o-form-group>
                  <br><br>
                  <br><br>
                </b-col>
            </b-row>
        </template>
    </o-form>
</template>


<script>
  import { VueEditor } from 'vue2-editor'
  export default {
    components: { VueEditor },
    data: () => ({
        types: [],
        customToolbar:[
          ["bold", "italic", "underline", "strike"],
          [
            { align: "" },
            { align: "center" },
            { align: "right" },
            { align: "justify" }
          ],
          [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ color: [] }, { background: [] }],
          ["link"],
          ["clean"]
        ]
    }),
    created() {
      this.types = [
        {value: 'normal', text: this.$i18n.t('sandoz.normal')},
        {value: 'chargeback', text: this.$i18n.t('sandoz.chargeback')},
      ]
    }
}
</script>
<style lang='css'>
@import '~vue2-editor/dist/vue2-editor.css';
</style>


